import React from "react";
import { SOCIAL_MEDIA_LINKS_COMMUNITY } from "./common/Helper";
import Icons from "./common/Icons";
import Paragraph from "./custom-ui/Paragraph";
import PrimaryHeading from "./custom-ui/PrimaryHeading";

function JoinDunceCommunity() {
  return (
    <div
      id="join-dunce-community"
      className="container custom-1700:pt-[100px] 2xl:pt-20 lg:pt-14 sm:pt-10 pt-[70px] 2xl:max-w-[1246px] xl:max-w-[1240px] mx-auto lg:px-5 md:px-8 px-5 text-center "
    >
      {/* Main heading for the section */}
      <PrimaryHeading children="Join Dunce Community" />

      {/* Description about the community */}
      <Paragraph
        className="md:pt-[30px] sm:pt-6 pt-4 font-roboto roboto-wide !font-medium text-dark-purple max-w-[353px] mx-auto sm:max-w-[unset] !text-base md:!text-lg xl:!text-2xl"
        children="Community is everything. We thrive on the support and enthusiasm of our holders. Participate in our events, engage in discussions, and contribute to the future of Dunce Coin. Whether it's through our vibrant social media channels, interactive forums, or community-led initiatives, there’s a place for everyone."
      />

      {/* Additional paragraph with more details */}
      <Paragraph
        className="md:pt-8 sm:pt-6 pt-4 sm:pb-[45px] pb-7 xl:pb-[60px] font-roboto roboto-wide !font-medium text-dark-purple leading-7 lg:leading-9 !text-base md:!text-lg xl:!text-2xl"
        children="Be a part of the Dunce Coin family and enjoy exclusive perks, early access to news, and the camaraderie of fellow crypto enthusiasts. Together, we’re making waves in the crypto world!"
      />

      {/* Container for social media icons */}
      <div className="text-center mx-auto flex gap-[30px] md:gap-10 xl:gap-10 2xl:gap-[60px] justify-center items-center pb-[45px] md:pb-[60px] lg:pb-[90px] 2xl:pb-[130px]">
        {/* Discord icon link */}
        {SOCIAL_MEDIA_LINKS_COMMUNITY.map((value, index) => (
          <a
            key={index}
            href={value.link}
            target="_blank"
            aria-label="social-links"
          >
            <Icons
              icon={value.icon}
              className="h-[62.1px] w-[62.1px] bg-royal-blue md:h-full md:w-[70px] xl:w-[100px] 2xl:w-[124.5px] rounded-[50%] transition-all duration-300 ease-in-out hover:translate-y-2"
            />
          </a>
        ))}
      </div>
    </div>
  );
}

export default JoinDunceCommunity;
